<script lang="ts">
	import { MaterialApp } from 'svelte-materialify';
	import { Snackbar } from 'svelte-materialify/src';
	import Nav from './Nav.svelte';
	import './firestore';
	import { error, feedback } from './stores';

	let showError = false, showFeedback = false;
	error.subscribe(it => {
		if (it !== null) {
			showError = true;
			setTimeout(() => showError = false, 15*1000);
		}
	});
	feedback.subscribe(it => {
		if (it !== null) {
			showFeedback = true;
			setTimeout(() => feedback.set(null), 3000);
		} else {
			showFeedback = false;
		}
	});
</script>

<MaterialApp>
	<Nav></Nav>
</MaterialApp>

<Snackbar bottom center bind:active={showError}>
	Error: {$error.message}
</Snackbar>

<Snackbar bottom center bind:active={showFeedback}>
	{$feedback}
</Snackbar>

<style>
</style>